function getUserData(formContext, callback) {
  let gmpSessionId;

  if (window.gtag && formContext.gmpTarget) {
    let resolved = false;
    const timeout = setTimeout(() => {
      if (!resolved) {
        resolved = true;
        callback(new Error('timeout'), {gmpSessionId});
      }
    }, 5000);

    window.gtag('get', formContext.gmpTarget, 'session_id', id => {
      if (!resolved) {
        resolved = true;
        clearTimeout(timeout);
        if (id) gmpSessionId = id;
        callback(null, {gmpSessionId});
      }
    });
  } else {
    callback(null, {gmpSessionId});
  }
}

module.exports = getUserData;
